import React, { useEffect } from "react";
import anime from "animejs";

import "../main.css";

import { Formacion } from "../Components/sections/Formacion";
import { Home } from "../Components/sections/Home";
import { Experiencia } from "../Components/sections/Experiencia";
import { Conocimientos } from "../Components/sections/Conocimientos";
import { Certificados } from "../Components/sections/Certificados";
import { Cursos } from "../Components/sections/Cursos";
import { Proyectos } from "../Components/sections/Proyectos";
import { ContactForm } from "../Components/sections/ContactForm";
import { Referencias } from "../Components/sections/Referencias";
import { Footer } from "../Components/sections/Footer";
import { Cita } from "../Components/sections/Cita";
import { Navbar } from "../Components/UI/Navbar";
import { Skills } from "../Components/sections/Skills";
// import { Lang } from "../translations/component/Lang";

const Portafolio = () => {
	useEffect(() => {
		let tl = anime.timeline({
			easing: "easeInOutExpo",
			duration: 950,
		});

		tl.add({
			targets: ".section div",
			width: "100%",
			backgroundColor: "rgb(197, 197, 255)",
			zIndex: 5,
			delay: anime.stagger(100),
		});

		tl.add({
			targets: ".section div",
			width: "90%",
			backgroundColor: "rgb(235, 235, 255)",
		});

		tl.add(
			{
				targets: ".divs",
				opacity: 1,
				duration: 850,
			},
			"-=600"
		);
		tl.add(
			{
				targets: ".coverImage",
				opacity: 1,
				duration: 750,
			},
			"-=700"
		);
		tl.add(
			{
				targets: ".Big-Circle",
				opacity: 1,
				duration: 850,
			},
			"-=100"
		);

		let rotateME = anime({
			targets: ".section",
			scaleY: 2,
			scaleX: 2,
			translateX: "40%",
			rotate: "45deg",
			overflowX: "hidden",
			duration: 1050,
			autoplay: false,
		});
		setTimeout(() => {
			rotateME.play();
			window.scrollTo(0, 0);
		}, 750);
	}, []);

	return (
		<>
			{
				//<Lang/>
			}
			<Navbar />
			<div className="select-none overflow-x-hidden">
				<section className="section">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</section>

				<div id="home" className="mt-28">
					<Home />
					<Formacion />
					<Cita
						cita={"Education-is-not-a-product"}
						autor={"Bel Kaufman"}
						image={
							<img loading='lazy'
								src="https://res.cloudinary.com/devsing/image/upload/v1654288797/Portfolio/R_friumz.jpg"
								alt="Autor"
								className="rounded-full w-16 float-right relative mb-4 mr-3"
							/>
						}
					/>
				</div>
				<div id="exp">
					<Experiencia />
					<Conocimientos />
					<Cita
						cita={"Learn-from-yesterday"}
						autor={"Albert Einstein"}
						image={
							<img loading='lazy'
								src={
									"https://res.cloudinary.com/devsing/image/upload/v1654288814/Portfolio/D_ejzfbc.jpg"
								}
								alt="Autor"
								className="rounded-full w-16 float-right relative mb-4 mr-3"
							/>
						}
					/>
					<Certificados />
				</div>
				<div id="skill">
					<Skills />
					<Cita
						cita={"victor-hugo"}
						autor={"Victor Hugo"}
						image={
							<img loading='lazy'
								src={
									"https://res.cloudinary.com/devsing/image/upload/v1654288796/Portfolio/OIP_nmqnz6.jpg"
								}
								alt="Autor"
								className="rounded-full w-16 float-right relative mb-4 mr-3"
							/>
						}
					/>
					<Cursos />
					<Proyectos />
					<Cita
						cita={"jrr-Tolkien"}
						autor={"J.R.R Tolkien"}
						image={
							<img loading='lazy'
								src={
									"https://res.cloudinary.com/devsing/image/upload/v1654288804/Portfolio/5220b876ad4cb_800x533_jrptek.jpg"
								}
								alt="Autor"
								className="rounded-full w-16 float-right relative mb-4 mr-3"
							/>
						}
					/>
				</div>
				<Referencias />
				<div id="contact">
					<Cita
						cita={"Learn-from-yesterday"}
						autor={`Rancière, J. (6003)
    El maestro ignorante.
    Barcelona Laertes Educación.`}
						image={
							<img loading='lazy'
								src={
									"https://res.cloudinary.com/devsing/image/upload/v1654288796/Portfolio/R_2_tejtfq.jpg"
								}
								alt="Autor"
								className="rounded-full w-16 float-right relative mb-4 mr-3"
							/>
						}
					/>
					<ContactForm />
				</div>

				<Footer />
			</div>
		</>
	);
};

export default Portafolio;
